<template>
  <div class="app-layout authorized-layout" v-if="isAuthenticated">
    <Header />
    <div class="app-content">
      <slot />
      <profile-side-modal />
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./header";
import Footer from "../footer";
import ProfileSideModal from "components/pages/profile/profile-side-modal"

export default {
  name: "AuthorizedLayout",
  components: {
    Header,
    Footer,
    ProfileSideModal
  },
  data() {
    return {};
  },
  computed: {
    isAuthenticated() {
      return this.$auth.isAuthenticated;
    }
  },
  watch: {
    isAuthenticated: {
      handler(newValue) {
        if (newValue === false) {
          this.$router.replace('/login');
        }
      },
      immediate: true
    }
  },
};
</script>